


































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import { PicRec, PicTypeRec, PicList, PicListSet } from '@/interfaces';
import { networkErrorMessage } from '@/api';
import { commitAddNotification } from '@/store/main/mutations';
import { UploadStatus, enqueueUpload, setUploadState, withRetry } from '@/uploadQueue';
// import FileUpload from '@/components/FileUpload.vue';
// import DocPreviewDialog from '@/components/DocPreviewDialog.vue';

@Component({
  components: {
    // FileUpload, DocPreviewDialog
  }
})
export default class PictureListSet extends Mixins(CommonMixin) {
    // Props
    @Prop(String) public readonly title!: string;
    @Prop(String) public readonly baseurl!: string;
    @Prop(String) public readonly filebaseurl!: string;
    @Prop({ type: String, default: 'file' }) public readonly filekey!: string;
    @Prop() public picsets!: PicListSet[];
    @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;

    public dialogDelete: boolean = false;
    public dialogShowPic: boolean = false;
    public picUrl: string = '';
    public curPic2Upload: PicRec | null = null;
    public curKey2Upload: string = '';
    public curPic2Delete: PicRec | null = null;
    // Uploads in progress or failed, per picture slot (see picKey)
    public uploads: { [key: string]: UploadStatus } = {};

    public get picCount() {
        const counter = this.countPicSets(this.picsets);
        return '[' + counter.images + '/' + counter.total + ']';
    }
    public get isComplete() {
        const counter = this.countPicSets(this.picsets);
        return counter.images === counter.total;
    }
    public get uploadingCount() {
        return Object.values(this.uploads).filter(u => u.state === 'uploading').length;
    }
    public get failedCount() {
        return Object.values(this.uploads).filter(u => u.state === 'failed').length;
    }
    public picKey(picsetEntryIndex: number, picListEntry: PicList, picIndex: number) {
        return picsetEntryIndex + '.' + picListEntry.pictype.id + '.' + picIndex;
    }
    public globalKey(key: string) {
        return 'pics.' + (this as any)._uid + '.' + key;
    }
    public getRelImageURL(pic: PicRec) {
        return this.filebaseurl + pic.id + '/' + this.filekey;
    }
    public getImageURL(pic: PicRec, thumbWidth: number) {
        if (pic.file) {
            return pic.file.url + '?thumb_width=' + thumbWidth;
        } else {
            return '/img/placeholder-image.jpg';
        }
        // return 'https://picsum.photos/500/300?image=' + (Math.floor(Math.random() * 1000) + 1);
    }
    public getImageFName(pic: PicRec) {
        return pic.file ? pic.file.name : '';
    }
    public async checkImageRec(pic: PicRec) {
        if (pic.id <= 0) {
            const response = await this.api.createRecordOrThrow(this.baseurl, pic);
            pic.id = response.data.id;
        }
    }
    public clickImage(pic: PicRec, key: string) {
        const upload = this.uploads[key];
        if (upload) {
            if (upload.state === 'failed') {
                this.picUrl = upload.previewUrl;
                this.dialogShowPic = true;
            }
        } else if (pic.file) {
            this.picUrl = this.getImageURL(pic, 1000);
            this.dialogShowPic = true;
        } else if (!this.isReadOnly) {
            this.uploadImage(pic, key);
        }
    }
    public uploadImage(pic: PicRec, key: string, inputRef: string = 'fileInput') {
        // Open the file picker directly from the tap: iOS ignores the click when we wait
        // for the network first. The picture record is created when the upload starts.
        const fileInput: any = this.$refs[inputRef];
        if (fileInput) {
            this.curPic2Upload = pic;
            this.curKey2Upload = key;
            fileInput.value = ''; // reset any existing files
            fileInput.click();
        }
    }
    public handleFileInput(event) {
        const pic = this.curPic2Upload;
        const key = this.curKey2Upload;
        this.curPic2Upload = null;
        const files = event.target.files;
        if (pic && files && files.length) {
            // The backend (Pillow thumbnails, .jpg exports) cannot handle e.g. HEIC from Android phones
            if (files[0].type !== 'image/jpeg') {
                commitAddNotification(this.$store, {
                    content: 'Enkel JPG foto\'s zijn toegelaten (dit bestand is ' + (files[0].type || 'onbekend') + ').',
                    color: 'error'
                });
                return;
            }
            this.startUpload(pic, key, files[0]);
        } else {
            console.log('Nothing to upload');
        }
    }
    public retryUpload(pic: PicRec, key: string) {
        const upload = this.uploads[key];
        if (upload) {
            this.startUpload(pic, key, upload.file);
        }
    }
    public clearUpload(key: string) {
        const upload = this.uploads[key];
        if (upload) {
            URL.revokeObjectURL(upload.previewUrl);
            this.$delete(this.uploads, key);
        }
        setUploadState(this.globalKey(key), null);
    }
    public async startUpload(pic: PicRec, key: string, file: Blob) {
        this.clearUpload(key);
        const upload: UploadStatus = {state: 'uploading', progress: 0, error: '', file, previewUrl: URL.createObjectURL(file)};
        this.$set(this.uploads, key, upload);
        setUploadState(this.globalKey(key), 'uploading');
        try {
            const frec = await enqueueUpload(() => withRetry(async () => {
                upload.progress = 0;
                await this.checkImageRec(pic);
                const formData = new FormData();
                formData.append('file', file);
                const response = await this.api.uploadFileWithProgress(this.getRelImageURL(pic), formData, p => upload.progress = p);
                return response.data;
            }));
            if (this.uploads[key] === upload) {
                this.clearUpload(key);
            }
            this.handleUploadedFile(frec, pic);
        } catch (error) {
            upload.state = 'failed';
            upload.error = networkErrorMessage(error);
            if (this.uploads[key] === upload) {
                setUploadState(this.globalKey(key), 'failed');
            }
            commitAddNotification(this.$store, {
                content: 'Foto NIET opgeslagen (' + upload.error + '). Probeer opnieuw met de knop naast de foto.',
                color: 'error'
            });
        }
    }

    public handleUploadedFile(frec, pic) {
        // console.log('handleUploadedFile', frec);
        this.$set(pic as any, this.filekey, frec);
        this.$emit('update');
    }
    public async downloadImage(picsetEntry: PicListSet, picListEntry: PicList, pic: PicRec, picIndex: number) {
        // console.log('downloadImage', this.baseurl, pic, picIndex);
        if (pic.file) {
            this.api.downloadFileWithLink(this.$store, pic.file.url);
        }
    }
    public async deleteImage(pic: PicRec | null) {
        // console.log('deleteImage', this.baseurl, pic, picIndex);
        if (pic) {
            const response = await this.api.deleteRecord(this.$store, this.getRelImageURL(pic));
            if (response) {
                this.$set(pic, this.filekey, null);
                this.$emit('update');
            }
        }
    }


    public countPicSets(picsets: PicListSet[]) {
        // console.log('countPicSets')
        const counter = {images: 0, total: 0};
        for (const picsetEntry of picsets) {
            for (const picListEntry of picsetEntry.pics) {
                if (picListEntry.pictype.min_occurance !== 0) {
                    for (const pic of picListEntry.pics) {
                        counter.total += 1;
                        if (pic.file) {
                            counter.images += 1;
                        }
                    }
                }
            }
        }
        return counter;
    }
    public addOptional(picsetEntry, picsetEntryIndex, picListEntry, picListEntryIndex) {
        // console.log(picsetEntryIndex, picListEntryIndex);
        // The record is created when a picture is uploaded to it
        const pic: PicRec = {id: -1, context_index: picsetEntryIndex, onsitepicturetype_id: picListEntry.pictype.id, file: null};
        picListEntry.pics.push(pic);
    }

    public beforeDestroy() {
        for (const key of Object.keys(this.uploads)) {
            this.clearUpload(key);
        }
    }


}
